export default "__VITE_ASSET__4802d731__"